import React, { useContext, useEffect, useState } from "react";
import "../../../assests/css/admin/AdminFeeManagement.css";
import Adminmasterlayout from "../../../layouts/Adminmasterlayout/Adminmasterlayout";
import Swal from "sweetalert2";
import { AppContext } from "../../../context/Appcontext";
import axios from "axios";
import { Button, Spinner } from "react-bootstrap";

const AdminFeeManagement = () => {
  /* ── Form fields ─────────────────────────────────────── */
  const { baseUrl } = useContext(AppContext);

  const [department, setDepartment] = useState();
  const [departments, setDepartments] = useState([]);
  const [academicYear, setAcademicYear] = useState();
  const [semester, setSemester] = useState();
  const [amount, setAmount] = useState();
  const [dueDate, setDueDate] = useState();
  const [lastDate, setLastDate] = useState();
  const [finalDeadline, setFinalDeadline] = useState();
  const [uploading, setUploading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [feeIdForUpdate, setFeeIdForUpdate] = useState(null);
  const [deletingId, setDeletingId] = useState(null);

  /* ── UI state ────────────────────────────────────────── */
  const [activeView, setActiveView] = useState("form");
  const [feeChallan, setFeeChallan] = useState([]);
  const [allChallans, setAllChallans] = useState([]);
  const [challanData, setChallanData] = useState(null);
  const [loading, setLoading] = useState(false);

  /* ── Static options ──────────────────────────────────── */
  // const departments = [
  //   'Computer Science',
  //   'Electrical Engineering',
  //   'Mechanical Engineering',
  //   'Civil Engineering',
  //   'Business Administration',
  //   'Mathematics',
  //   'Physics',
  //   'Chemistry',
  // ];
  const academicyears = ["1st Year", "2nd Year", "3rd Year", "4th Year"];
  const semesters = ["1", "2", "3", "4", "5", "6", "7", "8"];

  /* ── Helpers ─────────────────────────────────────────── */
  const resetForm = () => {
    setDepartment("");
    setAcademicYear("");
    setSemester("");
    setAmount("");
    setDueDate("");
    setLastDate("");
    setFinalDeadline("");
    setFeeIdForUpdate(null);
  };

  const addFeeChallan = () => {
    console.log(
      "*********** add fee challan wala function chl rha ha",
      department,
      semester,
      amount,
      academicYear,
      dueDate,
    );

    const formData = new FormData();
    // formData.append("ngdepartment_id", department);
    formData.append("ngdepartment_id", department);
    formData.append("semester", semester);
    formData.append("amount", amount);
    // formData.append("academicYear", academicYear);
    formData.append("dueDate", dueDate);
    formData.append("lastDate", lastDate);
    formData.append("finalDeadline", finalDeadline);
    // if (image) {
    // formData.append("image", image);
    // }

    setUploading(true);

    axios
      .post(`${baseUrl}/admin/feechallan/addFeeChallan`, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      })
      .then((response) => {
        console.log(response.data);
        setDepartment("");
        setSemester("");
        setAmount("");
        setDueDate("");
        viewAllFeeChallan();
      })
      .catch((error) => {
        console.log(error.response.data);
      })
      .finally(() => {
        setUploading(false);
      });
  };
  const viewAllFeeChallan = () => {
    setActiveView("table");
    axios
      .get(`${baseUrl}/admin/feechallan/viewAllFeeChallan`)
      .then((response) => {
        console.log(response.data);
        setFeeChallan(response.data.feeChallan);
      })
      .catch((error) => {
        console.log(error);
      });
  };
  //   const updateFeeChallan = () => {
  //     console.log("Updated ka function chl rha ha dehan sy dekho")
  //     const formData = new FormData();
  //     formData.append('feeChallan_id', feeIdForUpdate);
  //     formData.append("department", department);
  //     formData.append("semester", semester);
  //     formData.append("amount", amount);
  //     formData.append("academicYear", academicYear);
  //     formData.append("dueDate", dueDate);
  //     formData.append("lastDate", lastDate);
  //     formData.append("finalDeadline", finalDeadline);
  // axios
  //       .post(`${baseUrl}admin/feechallan/updateFeeChallan`, formData, {
  //         headers: { 'Content-Type': 'multipart/form-data' },
  //       })
  //       .then((response) => {
  //         console.log(response.data);
  //         viewAllFeeChallan();
  //         resetForm();
  //         setShowModal(false);
  //       })
  //       .catch((error) => {
  //         console.error(error);
  //       });
  //   };
  const viewAllDepartments = () => {
    axios
      .get(`${baseUrl}/admin/department/viewAllDepartments`)
      .then((response) => {
        console.log(response.data);
        setDepartments(response.data.departments);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const deleteSingleFeeChallan = (id) => {
    const formData = new FormData();
    formData.append("ngchallan_id", id);
    setDeletingId(id);
    axios
      .post(`${baseUrl}/admin/feechallan/deleteFeeChallan`, formData, {
        headers: {
          "Content-Type": "multipart-formdata",
        },
      })
      .then((response) => {
        console.log(response.data);
        viewAllFeeChallan();
      })
      .catch((error) => {
        console.log(error);
      })
      .finally(() => {
        setDeletingId(null);
      });
  };
  useEffect(() => {
    viewAllFeeChallan();
    viewAllDepartments();
  }, []);

  const handleSubmit = () => {
    if (feeIdForUpdate === null) {
      addFeeChallan();
      // } else {
      //   updateCourse();
    }
  };

  /* ── Event handlers ──────────────────────────────────── */
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    const setters = {
      department: setDepartment,
      academicyear: setAcademicYear,
      semester: setSemester,
      amount: setAmount,
      dueDate: setDueDate,
      lastDate: setLastDate,
      finaldeadline: setFinalDeadline,
    };
    if (setters[name]) setters[name](value);
  };

  const handleUpdateStatus = (id, newStatus) => {
    setAllChallans((prev) =>
      prev.map((c) => (c.id === id ? { ...c, paymentStatus: newStatus } : c)),
    );
    // updateFeeChallan(id, { paymentStatus: newStatus });
  };

  return (
    <Adminmasterlayout>
      <div className="afm-container">
        {/* ── Header ── */}
        <header className="afm-header">
          <div>
            <h1 className="afm-header__title">Fee Management</h1>
            <p className="afm-header__subtitle">
              Generate and manage student fee challans
            </p>
          </div>
          <div className="afm-header__actions">
            <button
              className={`afm-nav-btn ${activeView === "form" || activeView === "challan" ? "afm-nav-btn--active" : ""}`}
              onClick={() => setActiveView("form")}
            >
              Generate Challan
            </button>
            <button
              className={`afm-nav-btn ${activeView === "table" ? "afm-nav-btn--active" : ""}`}
              onClick={viewAllFeeChallan}
            >
              View All ({feeChallan.length})
            </button>
          </div>
        </header>

        {/* ── FORM VIEW ── */}
        {activeView === "form" && (
          <div className="afm-card">
            <h2 className="afm-card__heading">New Fee Challan</h2>
            <div className="afm-form-grid">
              {/* Department */}
              <div className="afm-form-group">
                <label className="afm-label" htmlFor="department">
                  Department *
                </label>
                <select
                  id="department"
                  name="department"
                  className="afm-select"
                  value={department}
                  onChange={(event) => setDepartment(event.target.value)}
                >
                  <option value="">Select Department</option>
                  {departments.map((dept) => (
                    <option key={dept} value={dept.id}>
                      {dept.deptName}
                    </option>
                  ))}
                </select>
              </div>

              {/* Academic Year */}
              {/* <div className="afm-form-group">
                <label className="afm-label" htmlFor="academicyear">Academic Year *</label>
                <select
                  id="academicyear"
                  name="academicyear"
                  className="afm-select"
                  value={academicYear}
                  onChange={(event) => setAcademicYear(event.target.value)}
                >
                  <option value="">Select Year</option>
                  {academicyears.map((y) => (
                    <option key={y} value={y}>{y}</option>
                  ))}
                </select>
              </div> */}

              {/* Semester */}
              <div className="afm-form-group">
                <label className="afm-label" htmlFor="semester">
                  Semester *
                </label>
                <select
                  id="semester"
                  name="semester"
                  className="afm-select"
                  value={semester}
                  onChange={(event) => setSemester(event.target.value)}
                >
                  <option value="">Select Semester</option>
                  {semesters.map((s) => (
                    <option key={s} value={s}>
                      {s}
                    </option>
                  ))}
                </select>
              </div>

              {/* Amount */}
              <div className="afm-form-group">
                <label className="afm-label" htmlFor="amount">
                  Amount (PKR) *
                </label>
                <input
                  type="number"
                  id="amount"
                  name="amount"
                  className="afm-input"
                  placeholder="e.g. 45000"
                  value={amount}
                  onChange={(event) => setAmount(event.target.value)}
                  min="0"
                />
              </div>

              {/* Due Date */}
              <div className="afm-form-group">
                <label className="afm-label" htmlFor="dueDate">
                  Due Date *
                </label>
                <input
                  type="date"
                  id="dueDate"
                  name="dueDate"
                  className="afm-input"
                  value={dueDate}
                  onChange={(event) => setDueDate(event.target.value)}
                />
              </div>

              {/* Last Date Without Fine */}
              {/* <div className="afm-form-group">
                <label className="afm-label" htmlFor="lastDate">Last Date (Without Fine) *</label>
                <input
                  type="date"
                  id="lastDate"
                  name="lastDate"
                  className="afm-input"
                  value={lastDate}
                  onChange={(event) => setLastDate(event.target.value)}
                />
              </div> */}

              {/* Final Deadline */}
              {/* <div className="afm-form-group">
                <label className="afm-label" htmlFor="finaldeadline">Final Deadline</label>
                <input
                  type="date"
                  id="finaldeadline"
                  name="finaldeadline"
                  className="afm-input"
                  value={finalDeadline}
                  onChange={(event) => setFinalDeadline(event.target.value)}
                />
              </div> */}
            </div>

            <div className="afm-form-actions">
              <button
                className="afm-btn afm-btn--secondary"
                onClick={resetForm}
                disabled={uploading}
              >
                Reset
              </button>
              {uploading ? (
                <Spinner size="lg" />
              ) : (
                <button
                  className="afm-btn afm-btn--primary"
                  onClick={handleSubmit}
                >
                  Generate Challan
                </button>
              )}
            </div>
          </div>
        )}

        {/* ── CHALLAN PREVIEW ── */}
        {activeView === "challan" && challanData && (
          <div className="afm-challan-wrapper">
            <div className="afm-challan" id="printable-challan">
              <div className="afm-challan__header">
                <div className="afm-challan__logo">🏛️</div>
                <div>
                  <h2 className="afm-challan__title">Fee Challan</h2>
                  <span className="afm-challan__number">
                    {challanData.challanNumber}
                  </span>
                </div>
                {/* <span className={`afm-badge afm-badge--${getStatusClass(challanData.paymentStatus)}`}>
                  {challanData.paymentStatus}
                </span> */}
              </div>

              <div className="afm-challan__grid">
                <div className="afm-challan__item">
                  <span className="afm-challan__item-label">Department</span>
                  <span className="afm-challan__item-value">
                    {challanData.department}
                  </span>
                </div>
                <div className="afm-challan__item">
                  <span className="afm-challan__item-label">Academic Year</span>
                  <span className="afm-challan__item-value">
                    {challanData.academicyear}
                  </span>
                </div>
                <div className="afm-challan__item">
                  <span className="afm-challan__item-label">Semester</span>
                  <span className="afm-challan__item-value">
                    {challanData.semester}
                  </span>
                </div>
                <div className="afm-challan__item">
                  <span className="afm-challan__item-label">Generated On</span>
                  <span className="afm-challan__item-value">
                    {challanData.generatedDate}
                  </span>
                </div>
                <div className="afm-challan__item afm-challan__item--highlight">
                  <span className="afm-challan__item-label">Total Amount</span>
                  <span className="afm-challan__item-amount">
                    PKR {parseInt(challanData.amount).toLocaleString()}
                  </span>
                </div>
                <div className="afm-challan__item">
                  <span className="afm-challan__item-label">Due Date</span>
                  <span className="afm-challan__item-value">
                    {new Date(challanData.dueDate).toLocaleDateString()}
                  </span>
                </div>
                <div className="afm-challan__item">
                  <span className="afm-challan__item-label">
                    Last Date (No Fine)
                  </span>
                  <span className="afm-challan__item-value">
                    {new Date(challanData.lastDate).toLocaleDateString()}
                  </span>
                </div>
                {challanData.finaldeadline && (
                  <div className="afm-challan__item">
                    <span className="afm-challan__item-label">
                      Final Deadline
                    </span>
                    <span className="afm-challan__item-value afm-challan__item-value--finaldeadline">
                      {new Date(challanData.finaldeadline).toLocaleDateString()}
                    </span>
                  </div>
                )}
              </div>

              <div className="afm-challan__footer">
                <p>
                  ⚠️ Please pay before the final finaldeadline to avoid late
                  payment charges.
                </p>
              </div>
            </div>

            <div className="afm-challan-actions">
              <button
                className="afm-btn afm-btn--secondary"
                onClick={resetForm}
              >
                New Challan
              </button>
              <button
                className="afm-btn afm-btn--ghost"
                onClick={() => setActiveView("table")}
              >
                View All
              </button>
              {/* <button className="afm-btn afm-btn--primary" onClick={handlePrint}>
                🖨️ Print
              </button> */}
            </div>
          </div>
        )}

        {/* ── TABLE VIEW ── */}
        {activeView === "table" && (
          <div className="afm-card afm-card--table">
            <div className="afm-table-header">
              <h2 className="afm-card__heading" style={{ margin: 0 }}>
                All Challans
                <span className="afm-count-badge">{feeChallan.length}</span>
              </h2>
              <button
                className="afm-btn afm-btn--primary"
                onClick={() => setActiveView("form")}
              >
                + New Challan
              </button>
            </div>

            {loading ? (
              <div className="afm-loading">Loading challans…</div>
            ) : feeChallan.length === 0 ? (
              <div className="afm-empty">
                <span className="afm-empty__icon">📄</span>
                <p className="afm-empty__text">No challans generated yet.</p>
                <button
                  className="afm-btn afm-btn--primary"
                  onClick={() => setActiveView("form")}
                >
                  Generate First Challan
                </button>
              </div>
            ) : (
              <div className="afm-table-scroll">
                <table className="afm-table">
                  <thead>
                    <tr>
                      <th>ID</th>
                      <th>Department</th>

                      <th>Semester</th>
                      <th>Amount (PKR)</th>

                      <th>Due Date</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {feeChallan.map((fee) => {
                      return (
                        <tr key={fee.id} className="tm-table__row">
                          <td className="afm-table__header">{fee.id}</td>
                          <td className="afm-table__header">
                            {fee.ngdepartment?.deptName}
                          </td>
                          <td className="afm-table__header">{fee.semester}</td>
                          <td className="afm-table__header">{fee.amount}</td>
                          {/* <td className="tm-table__header">{item.ngcourse?.name}</td> */}
                          <td className="afm__table-cell" data-label="Course">
                            {fee.dueDate}
                          </td>
                          <td className="afm__table-cell" data-label="Course">
                            {deletingId === fee.id ? (
                              <Spinner size="lg" />
                            ) : (
                              <button
                                className="afm-btn afm-btn--primary"
                                onClick={() => {
                                  deleteSingleFeeChallan(fee.id);
                                }}
                              >
                                Delete
                              </button>
                            )}
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            )}
          </div>
        )}
      </div>
    </Adminmasterlayout>
  );
};

export default AdminFeeManagement;